import React from "react";
import PropTypes from "prop-types";

import Item from "./Item";

const List = ({ isAdmin, currentUserId, data, onSignedUp }) => (
  <table className="table table-clean table-white">
    {data.length === 0 ? null : (
      <thead>
      <tr>
        <th>Location</th>
        <th>Date</th>
        <th>Instructor(s)</th>
        <th>Topic</th>
        <th/>
      </tr>
      </thead>
    )}
    <tbody>
    {data.map(item => (
      <Item
        key={item.id}
        isAdmin={isAdmin}
        currentUserId={currentUserId}
        data={item}
        onSignedUp={onSignedUp}
      />
    ))}
    {data.length === 0 ? (
      <tr>
        <td colSpan={6}>
          <h3 className="text-center">No in-services found.</h3>
        </td>
      </tr>
    ) : null}
    </tbody>
  </table>
);

List.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  currentUserId: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  onSignedUp: PropTypes.func.isRequired
};

export default List;
